var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetbrains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220 29",
    style: {
      enableBackground: "new 0 0 220 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,24.2l5-4.7c1.4,1.6,2.6,2.6,4.4,2.6c1.9,0,3.2-1.3,3.2-3.9V0.5h7.7v17.8c0,3.5-0.9,6-2.8,7.9 C15.7,28,13,29,9.8,29C5,29,2,26.9,0,24.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.7,0.5 46.2,0.5 46.2,7 31.4,7 31.4,11.3 44.8,11.3 44.8,17.5 31.4,17.5 31.4,21.9 46.4,21.9  46.4,28.5 23.7,28.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "56.1,7.3 47.8,7.3 47.8,0.5 72.3,0.5 72.3,7.3 63.9,7.3 63.9,28.5 56.1,28.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.7,0.5h14.4c3.5,0,6,0.9,7.6,2.5c1.1,1.2,1.8,2.6,1.8,4.6v0.1c0,3.2-1.8,5.2-4.3,6.2c3.4,1.1,5.6,3,5.6,6.8 v0.1c0,4.8-3.9,7.7-10.6,7.7H73.7L73.7,0.5z M89.8,9.1c0-1.6-1.2-2.4-3.5-2.4h-5.1v4.9h4.9C88.5,11.6,89.8,10.8,89.8,9.1L89.8,9.1z  M87.2,17.1h-5.9v5.2h6c2.4,0,3.7-0.9,3.7-2.6v-0.1C91,18.1,89.8,17.1,87.2,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.3,0.5h13.2c4.3,0,7.2,1.1,9.1,3c1.6,1.6,2.5,3.8,2.5,6.5v0.1c0,4.3-2.3,7.2-5.8,8.6l6.7,9.8h-8.9 l-5.6-8.5h-3.4v8.5h-7.8L100.3,0.5z M113.2,13.9c2.6,0,4.2-1.3,4.2-3.3v-0.1c0-2.2-1.6-3.4-4.2-3.4H108v6.8L113.2,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.2,0.3h7.5l11.9,28.2h-8.3l-2-5h-10.8l-2,5h-8.1L136.2,0.3z M143,17.4l-3.1-7.9l-3.2,7.9H143z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.4,
    y: 0.5,
    className: "st0",
    width: 7.8,
    height: 28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "168.3,0.5 175.5,0.5 187,15.3 187,0.5 194.7,0.5 194.7,28.5 187.9,28.5 175.9,13.1 175.9,28.5  168.3,28.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.6,24.3l4.3-5.2c2.8,2.2,5.8,3.4,9.1,3.4c2.1,0,3.2-0.7,3.2-1.9v-0.1c0-1.2-0.9-1.8-4.8-2.7 c-6-1.4-10.6-3-10.6-8.8V9c0-5.2,4.1-9,10.8-9c4.8,0,8.5,1.3,11.5,3.7l-3.9,5.5c-2.6-1.8-5.4-2.8-7.8-2.8c-1.9,0-2.8,0.8-2.8,1.8 v0.1c0,1.3,1,1.8,4.9,2.7c6.4,1.4,10.4,3.5,10.4,8.7v0.1c0,5.7-4.5,9.1-11.3,9.1C203.7,29,199,27.4,195.6,24.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetbrains);
export default __webpack_public_path__ + "static/media/Jetbrains.bd79f654340a6cba3157448dd79a4def.svg";
export { ForwardRef as ReactComponent };